import { Component, OnInit } from '@angular/core';
import {DefaultPageComponent} from "../../../shared/page/default-page.component";
import {AnalyticsPageModel} from "../../../shared/model/analyticsPage";
import {NavController} from "@ionic/angular";
import {BackNativeService} from "../../../shared/service/comunicator-native/back-native/back-native";
import {Title} from "@angular/platform-browser";
import {JourneyService} from "../../../shared/service/journey/journey.service";
import {AnalycticsNativeService} from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import {ReturnNativeService} from "../../../shared/service/comunicator-native/return-native/return-native";
import {AnalyticsPageService} from "../../../shared/service/analytics/analytics-page.service";
import {Location} from '@angular/common';

@Component({
  selector: 'app-info-data',
  templateUrl: './info-data.page.html',
  styleUrls: ['./info-data.page.scss'],
})
export class InfoDataPage extends DefaultPageComponent implements OnInit {

  headerId = 'info-data';
  titlePage = 'Dados profissionais';
  startStage = '';
  endStage = '';
  analyticsPage: AnalyticsPageModel;

  constructor(
      public router: NavController,
      public backNativeService: BackNativeService,
      private title: Title,
      private _location: Location,
      public journeyService: JourneyService,
      public analycticsNativeService: AnalycticsNativeService,
      public returnNativeService: ReturnNativeService,
      private analyticsPageService: AnalyticsPageService,
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.analyticsData();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  ionViewWillEnter() {
    this.headerFocus();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  getPageId(): string {
    return this.headerId;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  analyticsData() {
    // tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage?.infoData;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  analyticsEventClique() {
    // // tslint:disable-next-line:variable-name
    const it_eventcategory = 'Clique';
    // // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage?.infoData
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }
  

  backPage() {
    this.analyticsEventClique();
    this._location.back();
  }


}
